module.exports = [
  {
    year: '2024/25',
    label: '2024 | 2025',
    // fill this out next year
    suffix: '',
    template: 'criteria202425.js',
  },
  {
    year: '2023/24',
    label: '2023 | 2024',
    suffix: '/2023_24',
    template: 'criteria202324.js',
  },
  {
    year: '2022/23',
    label: '2022 | 2023',
    suffix: '/2022_23',
    template: 'criteria202223.js',
  },
  {
    year: '2021/22',
    label: '2021 | 2022',
    suffix: '/2021_22',
    template: 'criteria202122.js',
  },
  {
    year: '2020/21',
    label: '2020 | 2021',
    suffix: '/2020_21',
    template: 'criteria202021.js',
  },
  {
    year: '2019/20',
    label: '2019 | 2020',
    suffix: '/2019_20',
    template: 'criteria201920.js',
  },
  {
    year: '2018/19',
    label: '2018 | 2019',
    suffix: '/2018_19',
    template: 'criteria201819.js',
  },
  {
    year: '2017/18',
    label: '2017 | 2018',
    suffix: '/2017_18',
    template: 'criteria201718.js',
  },
  {
    year: '2016/17',
    label: '2016 | 2017',
    suffix: '/2016_17',
    template: 'criteria201617.js',
  },
]



// WEBPACK FOOTER //
// ./src/data/YearDefinitions.js